export default "__VITE_ASSET__70dc20a7__"